export default __webpack_public_path__ + "static/takopaddenburg-ab3c1089e15ef44a84741253468bbd64.png";